export const namespace = 'bills';
